import { userManager } from '../components/OidcProvider/OidcProvider';

const CONTENT_TYPE = 'application/json';

async function platformFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const opts = {
    credentials: 'include' as const,
    ...options,
  };
  opts.headers = {
    Accept: CONTENT_TYPE,
    ...(options.headers || {}),
  };
  
  // Add Authorization header if user is logged in via OIDC
  const user = await userManager.getUser();
  if (user && !user.expired && !(opts.headers as Record<string, string>)['Authorization']) {
    (opts.headers as Record<string, string>)['Authorization'] = `Bearer ${user.id_token}`;
  }
  
  if (opts.body) {
    if (typeof opts.body !== 'string') {
      opts.body = JSON.stringify(opts.body);
    }
    (opts.headers as Record<string, string>)['Content-Type'] = CONTENT_TYPE;
  }

  try {
    return await fetch(url, opts);
  } catch (err) {
    if (err instanceof Error) {
      throw err;
    }
    throw new Error('Network request failed');
  }
}

const http = {
  get: (url: string, options: RequestInit = {}): Promise<Response> => platformFetch(url, options),
  post: (url: string, body: BodyInit, options: RequestInit = {}): Promise<Response> =>
    platformFetch(url, {
      method: 'POST',
      body,
      ...options,
    }),
  put: (url: string, body: BodyInit): Promise<Response> =>
    platformFetch(url, {
      method: 'PUT',
      body,
    }),
  patch: (url: string, body: BodyInit): Promise<Response> =>
    platformFetch(url, {
      method: 'PATCH',
      body,
    }),
  delete: (url: string, options: RequestInit = {}): Promise<Response> =>
    platformFetch(url, {
      method: 'DELETE',
      ...options,
    }),
};

export default http;
